/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { handleResponse } from '@opengeoweb/api';
import type { InitialAppPreset } from '@opengeoweb/core';
import { sessionStorageProvider } from '@opengeoweb/shared';

export const getInitialPresets = async (
  filename: string,
): Promise<InitialAppPreset> => {
  return fetch(`./assets/${filename}`).then(
    handleResponse,
  ) as Promise<InitialAppPreset>;
};

export const getBeVersion = async (): Promise<{ version: string }> => {
  const config = sessionStorageProvider.getConfig();
  const baseUrl = config.GW_BE_VERSION_BASE_URL ?? '';
  const url = `${baseUrl.replace(/\/$/, '')}/version`;
  return fetch(url).then(handleResponse) as Promise<{ version: string }>;
};
